import L from "leaflet";

export function addTileLayer(map) {
  L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
    attribution: "ip-tracker",
  }).addTo(map);
}
